<template>
  <div v-if="notice" class="site-notice">
    <div class="inner">
      <a :href="`/information?id=${notice.id}`" @click.prevent="open">
        <span class="ic">⚠</span>
        <b>{{ notice.date }}</b>
        <span class="t">{{ notice.title }}</span>
        <span class="more">{{ $t('notice.more') }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import { loadUpcomingNotice } from '@/data/upcomingNotice'

/**
 * お知らせのうち「日付がまだ来ていない、いちばん近いもの」を表示する。
 * 該当が無ければバー自体を表示しない。クリックでお知らせ詳細へ。
 */
export default {
  name: 'SiteNotice',
  data() {
    return { notice: null }
  },
  created() {
    loadUpcomingNotice().then(n => { this.notice = n })
  },
  methods: {
    // 既存仕様に合わせ、スマホは /infoitem、PC は /information で詳細を表示
    open() {
      const path = window.innerWidth < 768 ? '/infoitem' : '/information'
      this.$router.push({ path: this.$lp(path), query: { id: this.notice.id } }).catch(() => {})
    },
  },
}
</script>

<style scoped>
.site-notice{background:#fff4e5;border-bottom:1px solid #f6dcb4;line-height:1.5}
.inner{max-width:1284px;margin:0 auto;padding:7px 16px;box-sizing:border-box}
.inner a{display:flex;align-items:baseline;gap:6px;color:#8a4b00;font-size:13px;text-decoration:none;min-width:0}
.ic{flex:none}
b{flex:none}
.t{min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.more{flex:none;text-decoration:underline;margin-left:auto;padding-left:6px}
</style>
